export default __webpack_public_path__ + "static/media/Snd_Try9.9c98129c.mp3";